var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Assignees",

    getDefaultProps () {
        return {"width":"22px","height":"22px","viewBox":"0 0 22 22","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Icon/Assignees</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Icon/Assignees" fill="#000000">
      <path d="M15,10 C16.7,10 18,8.7 18,7 C18,5.3 16.7,4 15,4 C13.3,4 12,5.3 12,7 C12,8.7 13.3,10 15,10 L15,10 Z M7,10 C8.7,10 10,8.7 10,7 C10,5.3 8.7,4 7,4 C5.3,4 4,5.3 4,7 C4,8.7 5.3,10 7,10 L7,10 Z M7,12 C4.7,12 0,13.2 0,15.5 L0,18 L14,18 L14,15.5 C14,13.2 9.3,12 7,12 L7,12 Z M15,12 C14.7,12 14.4,12 14,12.1 C15.2,12.9 16,14.1 16,15.5 L16,18 L22,18 L22,15.5 C22,13.2 17.3,12 15,12 L15,12 Z" id="Shape"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/ui/images/Assignees.svg